import { render, staticRenderFns } from "./TheDebug.vue?vue&type=template&id=3d530ab0&scoped=true&"
import script from "./TheDebug.vue?vue&type=script&lang=js&"
export * from "./TheDebug.vue?vue&type=script&lang=js&"
import style0 from "./TheDebug.vue?vue&type=style&index=0&id=3d530ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d530ab0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d530ab0')) {
      api.createRecord('3d530ab0', component.options)
    } else {
      api.reload('3d530ab0', component.options)
    }
    module.hot.accept("./TheDebug.vue?vue&type=template&id=3d530ab0&scoped=true&", function () {
      api.rerender('3d530ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Debug/TheDebug.vue"
export default component.exports